import { useCallback, useState } from 'react'

import { planGateCopy, type PlanGateFeature } from '../billing/paywallCopy'
import { PaywallModal } from '../components/billing/PaywallModal'
import { useBuyerEntitlements } from './useBuyerEntitlements'

export type { PlanGateFeature }

type PaywallState = {
  title: string
  message: string
}

export const usePlanGate = () => {
  const entitlements = useBuyerEntitlements()
  const [paywall, setPaywall] = useState<PaywallState | null>(null)

  const isFeatureEnabled = useCallback(
    (feature: PlanGateFeature) => {
      switch (feature) {
        case 'market_catalog':
          return entitlements.marketCatalogEnabled
        case 'platform_rfq':
          return entitlements.platformRfqEnabled
        case 'platform_chat':
          return entitlements.platformChatEnabled
        case 'buyer_suppliers':
          return entitlements.buyerSuppliersEnabled
        case 'market_price_intelligence':
          return entitlements.marketPriceIntelligenceEnabled
        default:
          return true
      }
    },
    [entitlements],
  )

  const requestFeature = useCallback(
    (feature: PlanGateFeature): boolean => {
      if (isFeatureEnabled(feature)) {
        return true
      }
      const copy = planGateCopy[feature]
      setPaywall({
        title: copy.title,
        message: copy.message,
      })
      return false
    },
    [isFeatureEnabled],
  )

  const paywallModal = (
    <PaywallModal
      open={paywall != null}
      title={paywall?.title ?? ''}
      message={paywall?.message ?? ''}
      onDismiss={() => setPaywall(null)}
    />
  )

  return {
    entitlements,
    isFeatureEnabled,
    requestFeature,
    paywallModal,
  }
}
